import React from 'react'
import { Heading } from '../HeadingModule/Heading'
import { Subheading } from '../HeadingModule/Subheading'
import '../../styles/AdsModule/AdsHeading.scss'

export const AdsHeading = () => {
  return <div className="ads-module-header">
        <Heading text="Check out these products that can impact your {highlight}finances{/highlight}" as="h2" />
        <Subheading text="Start working towards financial wealth and security by exploring these low-cost opportunities." />
    </div>
}
